import { SelectOptions } from "@components/sectorGuide/Select";

export const MUNICIPALITY_OPTIONS: SelectOptions[] = [
  { value: "Jag bor inte i Sverige", name: "Jag bor inte i Sverige" },
  { value: "Ale", name: "Ale" },
  { value: "Alingsås", name: "Alingsås" },
  { value: "Alvesta", name: "Alvesta" },
  { value: "Aneby", name: "Aneby" },
  { value: "Arboga", name: "Arboga" },
  { value: "Arjeplog", name: "Arjeplog" },
  { value: "Arvidsjaur", name: "Arvidsjaur" },
  { value: "Arvika", name: "Arvika" },
  { value: "Askersund", name: "Askersund" },
  { value: "Avesta", name: "Avesta" },

  { value: "Bengtsfors", name: "Bengtsfors" },
  { value: "Berg", name: "Berg" },
  { value: "Bjurholm", name: "Bjurholm" },
  { value: "Bjuv", name: "Bjuv" },
  { value: "Boden", name: "Boden" },
  { value: "Bollebygd", name: "Bollebygd" },
  { value: "Bollnäs", name: "Bollnäs" },
  { value: "Borgholm", name: "Borgholm" },
  { value: "Borlänge", name: "Borlänge" },
  { value: "Borås", name: "Borås" },
  { value: "Botkyrka", name: "Botkyrka" },
  { value: "Boxholm", name: "Boxholm" },
  { value: "Bromölla", name: "Bromölla" },
  { value: "Bräcke", name: "Bräcke" },
  { value: "Burlöv", name: "Burlöv" },
  { value: "Båstad", name: "Båstad" },

  { value: "Dals-Ed", name: "Dals-Ed" },
  { value: "Danderyd", name: "Danderyd" },
  { value: "Degerfors", name: "Degerfors" },
  { value: "Dorotea", name: "Dorotea" },

  { value: "Eda", name: "Eda" },
  { value: "Ekerö", name: "Ekerö" },
  { value: "Eksjö", name: "Eksjö" },
  { value: "Emmaboda", name: "Emmaboda" },
  { value: "Enköping", name: "Enköping" },
  { value: "Eskilstuna", name: "Eskilstuna" },
  { value: "Eslöv", name: "Eslöv" },
  { value: "Essunga", name: "Essunga" },

  { value: "Fagersta", name: "Fagersta" },
  { value: "Falkenberg", name: "Falkenberg" },
  { value: "Falköping", name: "Falköping" },
  { value: "Falun", name: "Falun" },
  { value: "Filipstad", name: "Filipstad" },
  { value: "Finspång", name: "Finspång" },
  { value: "Flen", name: "Flen" },
  { value: "Forshaga", name: "Forshaga" },
  { value: "Färgelanda", name: "Färgelanda" },

  { value: "Gagnef", name: "Gagnef" },
  { value: "Gislaved", name: "Gislaved" },
  { value: "Gnesta", name: "Gnesta" },
  { value: "Gnosjö", name: "Gnosjö" },
  { value: "Gotland", name: "Gotland" },
  { value: "Grums", name: "Grums" },
  { value: "Grästorp", name: "Grästorp" },
  { value: "Gullspång", name: "Gullspång" },
  { value: "Gällivare", name: "Gällivare" },
  { value: "Gävle", name: "Gävle" },
  { value: "Göteborg", name: "Göteborg" },
  { value: "Götene", name: "Götene" },

  { value: "Habo", name: "Habo" },
  { value: "Hagfors", name: "Hagfors" },
  { value: "Hallsberg", name: "Hallsberg" },
  { value: "Hallstahammar", name: "Hallstahammar" },
  { value: "Halmstad", name: "Halmstad" },
  { value: "Hammarö", name: "Hammarö" },
  { value: "Haninge", name: "Haninge" },
  { value: "Haparanda", name: "Haparanda" },
  { value: "Heby", name: "Heby" },
  { value: "Hedemora", name: "Hedemora" },
  { value: "Helsingborg", name: "Helsingborg" },
  { value: "Herrljunga", name: "Herrljunga" },
  { value: "Hjo", name: "Hjo" },
  { value: "Hofors", name: "Hofors" },
  { value: "Huddinge", name: "Huddinge" },
  { value: "Hudiksvall", name: "Hudiksvall" },
  { value: "Hultsfred", name: "Hultsfred" },
  { value: "Hylte", name: "Hylte" },
  { value: "Håbo", name: "Håbo" },
  { value: "Hällefors", name: "Hällefors" },
  { value: "Härjedalen", name: "Härjedalen" },
  { value: "Härnösand", name: "Härnösand" },
  { value: "Härryda", name: "Härryda" },
  { value: "Hässleholm", name: "Hässleholm" },
  { value: "Höganäs", name: "Höganäs" },
  { value: "Högsby", name: "Högsby" },
  { value: "Hörby", name: "Hörby" },
  { value: "Höör", name: "Höör" },

  { value: "Jokkmokk", name: "Jokkmokk" },
  { value: "Järfälla", name: "Järfälla" },
  { value: "Jönköping", name: "Jönköping" },

  { value: "Kalix", name: "Kalix" },
  { value: "Kalmar", name: "Kalmar" },
  { value: "Karlsborg", name: "Karlsborg" },
  { value: "Karlshamn", name: "Karlshamn" },
  { value: "Karlskoga", name: "Karlskoga" },
  { value: "Karlskrona", name: "Karlskrona" },
  { value: "Karlstad", name: "Karlstad" },
  { value: "Katrineholm", name: "Katrineholm" },
  { value: "Kil", name: "Kil" },
  { value: "Kinda", name: "Kinda" },
  { value: "Kiruna", name: "Kiruna" },
  { value: "Klippan", name: "Klippan" },
  { value: "Knivsta", name: "Knivsta" },
  { value: "Kramfors", name: "Kramfors" },
  { value: "Kristianstad", name: "Kristianstad" },
  { value: "Kristinehamn", name: "Kristinehamn" },
  { value: "Krokom", name: "Krokom" },
  { value: "Kumla", name: "Kumla" },
  { value: "Kungsbacka", name: "Kungsbacka" },
  { value: "Kungsör", name: "Kungsör" },
  { value: "Kungälv", name: "Kungälv" },
  { value: "Kävlinge", name: "Kävlinge" },
  { value: "Köping", name: "Köping" },

  { value: "Laholm", name: "Laholm" },
  { value: "Landskrona", name: "Landskrona" },
  { value: "Laxå", name: "Laxå" },
  { value: "Lekeberg", name: "Lekeberg" },
  { value: "Leksand", name: "Leksand" },
  { value: "Lerum", name: "Lerum" },
  { value: "Lessebo", name: "Lessebo" },
  { value: "Lidingö", name: "Lidingö" },
  { value: "Lilla Edet", name: "Lilla Edet" },
  { value: "Lindesberg", name: "Lindesberg" },
  { value: "Linköping", name: "Linköping" },
  { value: "Ljungby", name: "Ljungby" },
  { value: "Ljusdal", name: "Ljusdal" },
  { value: "Ljusnarsberg", name: "Ljusnarsberg" },
  { value: "Lomma", name: "Lomma" },
  { value: "Ludvika", name: "Ludvika" },
  { value: "Luleå", name: "Luleå" },
  { value: "Lund", name: "Lund" },

  { value: "Malmö", name: "Malmö" },
  { value: "Malung-Sälen", name: "Malung-Sälen" },
  { value: "Mariestad", name: "Mariestad" },
  { value: "Mark", name: "Mark" },
  { value: "Markaryd", name: "Markaryd" },
  { value: "Mellerud", name: "Mellerud" },
  { value: "Mjölby", name: "Mjölby" },
  { value: "Mora", name: "Mora" },
  { value: "Motala", name: "Motala" },
  { value: "Mullsjö", name: "Mullsjö" },
  { value: "Munkedal", name: "Munkedal" },
  { value: "Munkfors", name: "Munkfors" },
  { value: "Mörbylånga", name: "Mörbylånga" },

  { value: "Nacka", name: "Nacka" },
  { value: "Nora", name: "Nora" },
  { value: "Norberg", name: "Norberg" },
  { value: "Nordanstig", name: "Nordanstig" },
  { value: "Nordmaling", name: "Nordmaling" },
  { value: "Norrköping", name: "Norrköping" },
  { value: "Norrtälje", name: "Norrtälje" },
  { value: "Norsjö", name: "Norsjö" },
  { value: "Nybro", name: "Nybro" },
  { value: "Nykvarn", name: "Nykvarn" },
  { value: "Nyköping", name: "Nyköping" },
  { value: "Nynäshamn", name: "Nynäshamn" },
  { value: "Nässjö", name: "Nässjö" },

  { value: "Ockelbo", name: "Ockelbo" },
  { value: "Olofström", name: "Olofström" },
  { value: "Orsa", name: "Orsa" },
  { value: "Orust", name: "Orust" },
  { value: "Osby", name: "Osby" },
  { value: "Oskarshamn", name: "Oskarshamn" },
  { value: "Ovanåker", name: "Ovanåker" },
  { value: "Oxelösund", name: "Oxelösund" },

  { value: "Pajala", name: "Pajala" },
  { value: "Partille", name: "Partille" },
  { value: "Perstorp", name: "Perstorp" },
  { value: "Piteå", name: "Piteå" },

  { value: "Ragunda", name: "Ragunda" },
  { value: "Robertsfors", name: "Robertsfors" },
  { value: "Ronneby", name: "Ronneby" },
  { value: "Rättvik", name: "Rättvik" },

  { value: "Salem", name: "Salem" },
  { value: "Sandviken", name: "Sandviken" },
  { value: "Sigtuna", name: "Sigtuna" },
  { value: "Simrishamn", name: "Simrishamn" },
  { value: "Sjöbo", name: "Sjöbo" },
  { value: "Skara", name: "Skara" },
  { value: "Skellefteå", name: "Skellefteå" },
  { value: "Skinnskatteberg", name: "Skinnskatteberg" },
  { value: "Skurup", name: "Skurup" },
  { value: "Skövde", name: "Skövde" },
  { value: "Smedjebacken", name: "Smedjebacken" },
  { value: "Sollefteå", name: "Sollefteå" },
  { value: "Sollentuna", name: "Sollentuna" },
  { value: "Solna", name: "Solna" },
  { value: "Sorsele", name: "Sorsele" },
  { value: "Sotenäs", name: "Sotenäs" },
  { value: "Staffanstorp", name: "Staffanstorp" },
  { value: "Stenungsund", name: "Stenungsund" },
  { value: "Stockholm", name: "Stockholm" },
  { value: "Storfors", name: "Storfors" },
  { value: "Storuman", name: "Storuman" },
  { value: "Strängnäs", name: "Strängnäs" },
  { value: "Strömstad", name: "Strömstad" },
  { value: "Strömsund", name: "Strömsund" },
  { value: "Sundbyberg", name: "Sundbyberg" },
  { value: "Sundsvall", name: "Sundsvall" },
  { value: "Svalöv", name: "Svalöv" },
  { value: "Svedala", name: "Svedala" },
  { value: "Svenljunga", name: "Svenljunga" },
  { value: "Säffle", name: "Säffle" },
  { value: "Säter", name: "Säter" },
  { value: "Sävsjö", name: "Sävsjö" },
  { value: "Söderhamn", name: "Söderhamn" },
  { value: "Söderköping", name: "Söderköping" },
  { value: "Södertälje", name: "Södertälje" },
  { value: "Sölvesborg", name: "Sölvesborg" },

  { value: "Tidaholm", name: "Tidaholm" },
  { value: "Tierp", name: "Tierp" },
  { value: "Timrå", name: "Timrå" },
  { value: "Tingsryd", name: "Tingsryd" },
  { value: "Tjörn", name: "Tjörn" },
  { value: "Tomelilla", name: "Tomelilla" },
  { value: "Torsby", name: "Torsby" },
  { value: "Torsås", name: "Torsås" },
  { value: "Tranemo", name: "Tranemo" },
  { value: "Tranås", name: "Tranås" },
  { value: "Trelleborg", name: "Trelleborg" },
  { value: "Trosa", name: "Trosa" },
  { value: "Tyresö", name: "Tyresö" },
  { value: "Täby", name: "Täby" },
  { value: "Tanum", name: "Tanum" },

  { value: "Uddevalla", name: "Uddevalla" },
  { value: "Ulricehamn", name: "Ulricehamn" },
  { value: "Umeå", name: "Umeå" },
  { value: "Upplands-Bro", name: "Upplands-Bro" },
  { value: "Upplands Väsby", name: "Upplands Väsby" },
  { value: "Uppsala", name: "Uppsala" },
  { value: "Uppvidinge", name: "Uppvidinge" },

  { value: "Vadstena", name: "Vadstena" },
  { value: "Vaggeryd", name: "Vaggeryd" },
  { value: "Valdemarsvik", name: "Valdemarsvik" },
  { value: "Vallentuna", name: "Vallentuna" },
  { value: "Vansbro", name: "Vansbro" },
  { value: "Vara", name: "Vara" },
  { value: "Varberg", name: "Varberg" },
  { value: "Vaxholm", name: "Vaxholm" },
  { value: "Vellinge", name: "Vellinge" },
  { value: "Vetlanda", name: "Vetlanda" },
  { value: "Vilhelmina", name: "Vilhelmina" },
  { value: "Vimmerby", name: "Vimmerby" },
  { value: "Vindeln", name: "Vindeln" },
  { value: "Vingåker", name: "Vingåker" },
  { value: "Vårgårda", name: "Vårgårda" },
  { value: "Vänersborg", name: "Vänersborg" },
  { value: "Vännäs", name: "Vännäs" },
  { value: "Värmdö", name: "Värmdö" },
  { value: "Värnamo", name: "Värnamo" },
  { value: "Västervik", name: "Västervik" },
  { value: "Västerås", name: "Västerås" },
  { value: "Växjö", name: "Växjö" },

  { value: "Ydre", name: "Ydre" },
  { value: "Ystad", name: "Ystad" },

  { value: "Åmål", name: "Åmål" },
  { value: "Ånge", name: "Ånge" },
  { value: "Åre", name: "Åre" },
  { value: "Årjäng", name: "Årjäng" },
  { value: "Åsele", name: "Åsele" },
  { value: "Åstorp", name: "Åstorp" },
  { value: "Åtvidaberg", name: "Åtvidaberg" },

  { value: "Älmhult", name: "Älmhult" },
  { value: "Älvdalen", name: "Älvdalen" },
  { value: "Älvkarleby", name: "Älvkarleby" },
  { value: "Älvsbyn", name: "Älvsbyn" },
  { value: "Ängelholm", name: "Ängelholm" },

  { value: "Öckerö", name: "Öckerö" },
  { value: "Ödeshög", name: "Ödeshög" },
  { value: "Örebro", name: "Örebro" },
  { value: "Örkelljunga", name: "Örkelljunga" },
  { value: "Örnsköldsvik", name: "Örnsköldsvik" },
  { value: "Östra Göinge", name: "Östra Göinge" },
  { value: "Östhammar", name: "Östhammar" },
  { value: "Österåker", name: "Österåker" },
  { value: "Östersund", name: "Östersund" },
  { value: "Övertorneå", name: "Övertorneå" },
];
